module.exports = __webpack_public_path__ + "img/interface-search.152154f4.jpg";